import Loading from '../../../../Dashboards/Common/Loading';
import { useOccurenceLocationChartsDataContext } from './hooks/useOccurenceLocationChartsDataContext';
import { OcurrenceLocation } from './OcurrenceLocation';
import { OcurrenceNeighborhood } from './OcurrenceNeighborhood';
import CityServices from './CityServices';
import { ResidentialNeighborhood } from './ResidentialNeighborhood';

export const Charts = () => {
    const { isLoading } = useOccurenceLocationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <OcurrenceLocation />
                <OcurrenceNeighborhood />
                <ResidentialNeighborhood />
            </div>
            <CityServices />
        </>
    );
};
